import { useState } from 'react'
import ChatHeader from './components/ChatHeader.jsx'
import DisclaimerBanner from './components/DisclaimerBanner.jsx'
import MessageList from './components/MessageList.jsx'
import ChatInput from './components/ChatInput.jsx'
import Watermark from './components/Watermark.jsx'
import { sendChatMessage } from './api/chat.js'
import './App.css'

const FALLBACK_REPLY =
  'I had trouble responding to your question. Please try again later.'

let nextId = 1

function App({ onBack }) {
  const [messages, setMessages] = useState([])
  const [showDisclaimer, setShowDisclaimer] = useState(true)
  const [isSending, setIsSending] = useState(false)

  const handleSend = async (text) => {
    const userMsg = { id: nextId++, role: 'user', text }
    const history = messages.map(({ role, text }) => ({ role, text }))
    setMessages((prev) => [...prev, userMsg])
    setIsSending(true)

    try {
      const reply = await sendChatMessage(text, history)
      setMessages((prev) => [
        ...prev,
        { id: nextId++, role: 'bot', text: reply || FALLBACK_REPLY },
      ])
    } catch {
      setMessages((prev) => [
        ...prev,
        { id: nextId++, role: 'bot', text: FALLBACK_REPLY },
      ])
    } finally {
      setIsSending(false)
    }
  }

  const handleClear = () => {
    setMessages([])
  }

  const handleBack = () => {
    if (onBack) {
      onBack()
      return
    }
    window.history.back()
  }

  return (
    <div className="app-shell">
      <Watermark />
      <ChatHeader onBack={handleBack} onClear={handleClear} />
      {showDisclaimer && (
        <DisclaimerBanner onDismiss={() => setShowDisclaimer(false)} />
      )}
      <MessageList messages={messages} />
      <ChatInput
        onSend={handleSend}
        disabled={isSending}
        hasStarted={messages.length > 0}
      />
    </div>
  )
}

export default App
